import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import addMinutes from 'date-fns/add_minutes';
import addHours from 'date-fns/add_hours';
import subHours from 'date-fns/sub_hours';
import { getExcelsDetail,getCompany,getUserAll, getTeamByCompany } from './core/cacheService'
import axios from 'axios';
class Convert {
  time: any;
  constructor (message: any) {
      this.time = message;
  }
  convertTime() : any {
    let timeC = this.time;
    let hours = Number(timeC.match(/^(\d+)/)[1]);
    let minutes = Number(timeC.match(/:(\d+)/)[1]);
    let AMPM = timeC.match(/\s(.*)$/)[1];
    if(AMPM == "PM" && hours<12) hours = hours+12;
    if(AMPM == "AM" && hours==12) hours = hours-12;
    let sHours = hours.toString();
    let sMinutes = minutes.toString();
    if(hours<10) sHours = "0" + sHours;
    if(minutes<10) sMinutes = "0" + sMinutes;
    return sHours + ":" + sMinutes;
  }
} 

const applyCompanyData = (companyData: any) => {
  // @see https://trello.com/c/DqT0uGfd/1850-power-ups-as-a-company-i-want-to-customize-my-performance-review-schedule-so-that-it-aligns-with-my-current-processes
  // default values
  if (!companyData.performance_review) {
    companyData.performance_review = {
      enabled: true,
      overdue: 2,
      pending: 1,
      ai_review_feedback: true,
      reset_completed_monthly: false,
    }
  }
  // TODO: Backend team needs to add 'enabled' field to company settings schema in Firebase
  if(companyData.performance_review.enabled == undefined){
    companyData.performance_review.enabled = true
  }
  if(companyData.performance_review.ai_review_feedback == undefined){
    companyData.performance_review.ai_review_feedback = true
  }
  if(companyData.reset_completed_monthly){
    companyData.performance_review.reset_completed_monthly = companyData.reset_completed_monthly
  }
  if (!companyData.limit) {
    companyData.limit = {
      openend: 3,
    }
  }

  // Town Hall Agent
  if (!_.has(companyData, "townhall_agent")) {
    companyData.townhall_agent = false;
  }

  // Town Hall Theme
  if (!_.has(companyData, 'townhall_themes')) {
    companyData.townhall_themes = [
      { key: 'innovation', name: 'Innovation' },
      { key: 'work-life-balance', name: 'Work-Life Balance' },
      { key: 'team-building', name: 'Team Building' },
      { key: 'problem-solving', name: 'Problem Solving' },
      { key: 'communication', name: 'Communication' },
      { key: 'leadership', name: 'Leadership' },
      { key: 'creativity', name: 'Creativity' },
      { key: 'adaptability', name: 'Adaptability' },
      { key: 'empathy', name: 'Empathy' },
      { key: 'time-management', name: 'Time Management' },
    ];
  }

  // Email Notifications - BACKEND TODO: Use these settings to control email sending
  // All default to true (ON) - users can disable specific notifications via settings UI
  // Backend should check these boolean values before sending any notification emails
  if (!_.has(companyData, 'email_notifications')) {
    companyData.email_notifications = {
      managerRewardRedemption: true,        // Manager gets email when team member redeems reward
      managerPeerFeedbackOutstanding: true, // Manager gets email when team member gets outstanding feedback
    };
  }
  if (!_.has(companyData, 'activity_feed_use_nickname')) {
    companyData.activity_feed_use_nickname = true;
  }
  if(!companyData.report_monthlyhr){
    companyData.report_monthlyhr = 'Y'
  }
  if(!companyData.report_activity_manager){
    companyData.report_activity_manager = 'Y'
  }
}

const hasOwn = (obj: any, key: string) => {
  return Object.prototype.hasOwnProperty.call(obj || {}, key)
}

const buildLanguageTemplate = (languageList: Array<any>) => {
  const languageTemplate: any = {}
  for (const lang of languageList || []) {
    if (!languageTemplate[lang.code]) {
      languageTemplate[lang.code] = ''
    }
  }
  return languageTemplate
}

const normalizeRecognitionValue = (item: any, key: string, order: number) => {
  const rawThai = hasOwn(item.names, 'th')
    ? item.names.th
    : item.name_th !== undefined
      ? item.name_th
      : item.labelTh

  const labelTh = !rawThai || rawThai === item.name ? '#' : rawThai

  return {
    ...item,
    names: {
      ...(item.names || {}),
      en: item.name,
      th: labelTh,
    },
    value: key,
    label: item.name,
    labelTh,
    order: item.order ? item.order : order,
  }
}

const normalizeExcelNames = (item: any, languageTemplate: any) => {
  const names = {
    ..._.clone(languageTemplate),
    ...(item.names || {}),
  }

  names.en = item.name

  if (!hasOwn(names, 'th')) {
    names.th = item.name_th && item.name_th !== item.name ? item.name_th : ''
  } else if (names.th === item.name) {
    names.th = ''
  }

  for (const lang in languageTemplate) {
    if (lang !== 'en' && names[lang] === item.name) {
      names[lang] = ''
    }
  }

  return names
}

export default {
    namespaced: true,
    state: {
      settingData: {
        starttime: '',
        report_dailyboss_time: '',
        report_weeklyboss_time: '',
        report_monthlyboss_time: '',
        report_monthlyhr: true,
        report_activity_manager: true,
        activity_feed_use_nickname: true,
      },
      excels:[],
      recognitionValue:[],
      hashTagId:'',
      oldRecognitionValue:[],
      settingDataMock: {},
      settingOldDataMock:[],
      multiLang:false,
      oldExcels:[],
      language:[],
      organization1level: [],
      memberinteam: [],
      memberInteamAll_master: [],
      memberInteamAll: [],
      allUser: [],
      member: [],
      presetlist:[],
      presetlistAll:[],
      loading_preset:false,
      townHallThemes: [],
      excels_detail:[],
    },
    mutations: {
      setDataSetting(state:any, result:any) {
        state.settingData = result
      },
      setExcels(state:any, result:any) {
        state.excels = result
      },
      setRecognitionValue(state:any, result:any) {
        state.recognitionValue = result
      },
      setOldRecognition(state:any, result:any) {
        state.oldRecognitionValue = result
      },
      sethashTagId(state:any, result:any) {
        state.hashTagId = result
      },
      setSettingDataMock(state:any, result:any) {
        state.settingDataMock = result
      },
      setSettingOldDataMock(state:any, result:any) {
        state.settingOldDataMock = result
      },
      setMultiLang(state:any, result:boolean) {
        state.multiLang = result
      },
      setOldExcels(state:any, result:boolean) {
        state.oldExcels = result
      },
      setlanguage(state:any, result:any){
        state.language = result
      },
      setMultipleState(state: any, payload: any) {
        Object.assign(state, payload)
      },
      setTownHallThemes(state:any, result:any) {
        state.townHallThemes = result
      },
      setExcelsDetail(state:any, result:any) {
        state.excels_detail = result
      }
    },
    actions: {
      async checkEngOnly({ commit, rootState, state, dispatch }: any){
        var BreakException = {};

        const LANG_FALLBACK:any = {
          'th': 'Thai',
          'ms': 'Bahasa Malaysia',
          'zh-HK': 'Chinese (Traditional, Hong Kong)',
          'pt-br': 'Brazilian Portuguese',
          'my': 'Burmese'
        }
        const materlanguage=(await firebase.database().ref(`/language`).once('value')).val()
      
        let language: { code: string; text: string }[] = [{code:"en",text:"English (Default)"}]
        if(state.multiLang === false){
          // for(const data in rootState.main.allUser){
            try {
                let arr = _.groupBy(rootState.main.allUser, function (b) {
                  return b.language;
                });
          
                if(Object.keys(arr).length>=1){
                    for(const i in arr){
                      let text=materlanguage[i]?materlanguage[i].name.toString():(LANG_FALLBACK[i]||'')
                      if(i!=='en' && i!=='undefined' && text){
                        language.push({code:i,text:text})
                      }
                    }
                    commit('setMultiLang',true)
                    commit('setlanguage',language)
                    dispatch('getExcelsByCompany')
                }
           
                // if(rootState.main.allUser[data].language !== undefined && rootState.main.allUser[data].language === 'th') {
                 
                //   commit('setMultiLang',true)
                //   throw BreakException;
                // }
              
            } catch (e) {
              if (e !== BreakException) throw e;
            }
          // }
          // firebase.database().ref(`users`).orderByChild("company").equalTo(rootState.authen.user.company).once('value', snapshot => {
          //   var BreakException = {};
          //   try {
          //     snapshot.forEach((data):any => {
          //       if(data.val().language !== undefined && data.val().language === 'th') {
                 
          //         commit('setMultiLang',true)
          //         throw BreakException;
          //       }
          //     });
          //   } catch (e) {
          //     if (e !== BreakException) throw e;
          //   }
          // });
        }
      },
      async getDataSetting({commit,dispatch,state}:any, user:any){
        const dateNow = new Date()
        let recognitionValue:Array<any>=[]
        let oldRecognitionValue:Array<any>=[]
        const companyData = await getCompany(user.company)
        if(companyData.timezone){
          const setlengthTimezone = [];
          setlengthTimezone['7'] = [4, 4.5, 5, 5.5, 5.75, 6, 6.5, 7, 8, 9, 9.5, 10];
          setlengthTimezone['-7'] = [-4, -5, -6, -7, -8, -9, -10];
          setlengthTimezone['0'] = [-3.5, -3, -2, -1, 0, 1, 2, 3, 3.5];
          let globalTime = 0
          if (setlengthTimezone['7'].indexOf( parseFloat(companyData.timezone)) !== -1)
              globalTime = 7;
          if (setlengthTimezone['-7'].indexOf( parseFloat(companyData.timezone)) !== -1)
              globalTime = -7;
          if (setlengthTimezone['0'].indexOf( parseFloat(companyData.timezone)) !== -1)
              globalTime = 0;

          const diffTimezone = companyData.timezone - globalTime
          if(companyData.starttime){
            let DailyPulse;
            // if(companyData.starttime_show){
            //   DailyPulse = companyData.starttime_show.split(":")
            // }else{
              DailyPulse = companyData.starttime.split(":")
            // }
            companyData.starttime = format(addHours(dateNow.setHours(DailyPulse[0], DailyPulse[1]),diffTimezone), 'h:mm A')
          }

          if(companyData.reminder_time){
            const DailyReminder = companyData.reminder_time.split(":")
            companyData.reminder_time = format(addHours(dateNow.setHours(DailyReminder[0], DailyReminder[1]),diffTimezone), 'h:mm A')
          }

          if(companyData.report_dailyboss_time){
            const DailyInsights = companyData.report_dailyboss_time.split(":")
            companyData.report_dailyboss_time = format(addHours(dateNow.setHours(DailyInsights[0], DailyInsights[1]),diffTimezone), 'h:mm A')
          }
  
          if(companyData.report_weeklyboss_time){
            const WeeklyInsights = companyData.report_weeklyboss_time.split(":")
            companyData.report_weeklyboss_time = format(addHours(dateNow.setHours(WeeklyInsights[0], WeeklyInsights[1]),diffTimezone), 'h:mm A')
          }
          if(companyData.report_monthlyboss_time){
            const monthlyInsights = companyData.report_monthlyboss_time.split(":")
            companyData.report_monthlyboss_time = format(addHours(dateNow.setHours(monthlyInsights[0], monthlyInsights[1]),diffTimezone), 'h:mm A')
          }
        }else{
          if(companyData.starttime){
            let DailyPulse;
            // if(companyData.starttime_show){
            //   DailyPulse = companyData.starttime_show.split(":")
            // }else{
              DailyPulse = companyData.starttime.split(":")
            // }
            companyData.starttime = format(dateNow.setHours(DailyPulse[0], DailyPulse[1]), 'h:mm A')
          }
  
          if(companyData.reminder_time){
            const DailyReminder = companyData.reminder_time.split(":")
            companyData.reminder_time = format(dateNow.setHours(DailyReminder[0], DailyReminder[1]), 'h:mm A')
          }
  
          if(companyData.report_dailyboss_time){
            const DailyInsights = companyData.report_dailyboss_time.split(":")
            companyData.report_dailyboss_time = format(dateNow.setHours(DailyInsights[0], DailyInsights[1]), 'h:mm A')
          }
  
          if(companyData.report_weeklyboss_time){
            const WeeklyInsights = companyData.report_weeklyboss_time.split(":")
            companyData.report_weeklyboss_time = format(dateNow.setHours(WeeklyInsights[0], WeeklyInsights[1]), 'h:mm A')
          }
          if(companyData.report_monthlyboss_time){
            const monthlyInsights = companyData.report_monthlyboss_time.split(":")
            companyData.report_monthlyboss_time = format(dateNow.setHours(monthlyInsights[0], monthlyInsights[1]), 'h:mm A')
          }
        }
        
        if(companyData.medal){
          if(companyData.medal.Creativity){
            companyData.Creativity = companyData.medal.Creativity
            companyData.CreativityTH =companyData.medals?companyData.medals.Creativity? companyData.medals.Creativity.th==companyData.medals.Creativity.en?"":companyData.medals.Creativity.th:"":""
          }

          if(companyData.medal.Initiative){
            companyData.Initiative = companyData.medal.Initiative
            companyData.InitiativeTH = companyData.medals?companyData.medals.Initiative? companyData.medals.Initiative.th==companyData.medals.Initiative.en?"":companyData.medals.Initiative.th:"":""
          }

          if(companyData.medal.Kindness){
            companyData.Kindness = companyData.medal.Kindness
            companyData.KindnessTH = companyData.medals?companyData.medals.Kindness? companyData.medals.Kindness.th==companyData.medals.Kindness.en?"":companyData.medals.Kindness.th:"":""
          }

          if(companyData.medal.Strength){
            companyData.Strength = companyData.medal.Strength
            companyData.StrengthTH = companyData.medals?companyData.medals.Strength? companyData.medals.Strength.th==companyData.medals.Strength.en?"":companyData.medals.Strength.th:"":""
          }

          if(companyData.medal.Charisma){
            companyData.Charisma = companyData.medal.Charisma
            companyData.CharismaTH =companyData.medals?companyData.medals.Charisma? companyData.medals.Charisma.th==companyData.medals.Charisma.en?"":companyData.medals.Charisma.th:"":""
          }

          if(companyData.medal.Intelligence){
            companyData.Intelligence = companyData.medal.Intelligence
            companyData.IntelligenceTH =companyData.medals?companyData.medals.Intelligence? companyData.medals.Intelligence.th==companyData.medals.Intelligence.en?"":companyData.medals.Intelligence.th:"":""
          }

        }else{
          companyData.Creativity = "Creativity"
          companyData.Initiative = "Initiative"
          companyData.Kindness = "Kindness"
          companyData.Strength = "Strength"
          companyData.Charisma = "Charisma"
          companyData.Intelligence = "Intelligence"

        }
        if(!companyData.medals){
          companyData.CreativityTH = ""
          companyData.InitiativeTH = ""
          companyData.KindnessTH = ""
          companyData.StrengthTH = ""
          companyData.CharismaTH = ""
          companyData.IntelligenceTH = ""

        }
        if(companyData['holiday_tag'] === undefined){
          companyData['holiday_tag'] = new Array()
        }
        if(companyData['holiday_val'] === undefined){
          companyData['holiday_val'] = new Array()
        }
        await firebase.firestore().collection('holliday').where("companyid", "==", user.company).where("date",">=",format(dateNow, 'YYYY-MM-DD')).orderBy('date').get()
        .then(function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
                const data = doc.data();
                let date_holiday = data['date'].split("-");

                companyData['holiday_tag'].push(format(data['date'], 'dddd, MMMM D, YYYY'))
                companyData['holiday_val'].push(new Date(`${date_holiday[0]}/${date_holiday[1]}/${date_holiday[2]}`))
            });
        });
        let count=0
        for(var value in companyData.hashtag){
          count++

          const normalizedRecognition = normalizeRecognitionValue(
            companyData.hashtag[value],
            value,
            count
          )

          recognitionValue.push(normalizedRecognition);
          oldRecognitionValue.push(_.cloneDeep(normalizedRecognition));
        }
        // console.log('recognitionValue',recognitionValue)
          companyData.report_monthly_insights= companyData.report_monthlyboss?companyData.report_monthlyboss:"N"
          companyData.report_monthlyboss_time= companyData.report_monthlyboss_time
          companyData.happilyAssistAccess_checked= companyData.assist_access?companyData.assist_access:false
          companyData.medalsForLeaders_checked= companyData.leadership=="Y"?true:false
          companyData.recognitionValue_checked= companyData.hashtag_status? companyData.hashtag_status:false
          companyData.peerFeedbackInteractions_checked= companyData.peer_feedback=="Y"?true:false
          companyData.happilyVillageAccess_checked = companyData.house_village=="Y"?true:false
          companyData.create_topics= companyData.create_topics=="Y"?true:false

        applyCompanyData(companyData);
        companyData.townHallAgent_checked = Boolean(companyData.townhall_agent);
        companyData.townhall_themes = companyData.townhall_themes;
        companyData.emailNotifications = companyData.email_notifications;
        companyData.report_monthlyhr = companyData.report_monthlyhr == 'Y' ? true : false;
        companyData.report_activity_manager = companyData.report_activity_manager == 'Y' ? true : false;
        commit('setTownHallThemes', companyData.townhall_themes);

        recognitionValue=_.orderBy(recognitionValue,['order'],["asc"])
        oldRecognitionValue=_.orderBy(oldRecognitionValue,['order'],["asc"])
        commit('setOldRecognition',oldRecognitionValue) 
        commit('setRecognitionValue',recognitionValue)
        //console.log('companyData',companyData)
        commit('setDataSetting',companyData)
      },
      async getoldDataSetting({commit,dispatch,state}:any, user:any){
        const dateNow = new Date()
        let recognitionValue:Array<any>=[]
        let oldRecognitionValue:Array<any>=[]
        const companyData = await getCompany(user.company)
        
        if(companyData.timezone){
          const setlengthTimezone = [];
          setlengthTimezone['7'] = [4, 4.5, 5, 5.5, 5.75, 6, 6.5, 7, 8, 9, 9.5, 10];
          setlengthTimezone['-7'] = [-4, -5, -6, -7, -8, -9, -10];
          setlengthTimezone['0'] = [-3.5, -3, -2, -1, 0, 1, 2, 3, 3.5];
          let globalTime = 0
          if (setlengthTimezone['7'].indexOf( parseFloat(companyData.timezone)) !== -1)
              globalTime = 7;
          if (setlengthTimezone['-7'].indexOf( parseFloat(companyData.timezone)) !== -1)
              globalTime = -7;
          if (setlengthTimezone['0'].indexOf( parseFloat(companyData.timezone)) !== -1)
              globalTime = 0;

          const diffTimezone = companyData.timezone - globalTime
          if(companyData.starttime){
            let DailyPulse;
            // if(companyData.starttime_show){
            //   DailyPulse = companyData.starttime_show.split(":")
            // }else{
              DailyPulse = companyData.starttime.split(":")
            // }
            companyData.starttime = format(addHours(dateNow.setHours(DailyPulse[0], DailyPulse[1]),diffTimezone), 'h:mm A')
          }

          if(companyData.reminder_time){
            const DailyReminder = companyData.reminder_time.split(":")
            companyData.reminder_time = format(addHours(dateNow.setHours(DailyReminder[0], DailyReminder[1]),diffTimezone), 'h:mm A')
          }

          if(companyData.report_dailyboss_time){
            const DailyInsights = companyData.report_dailyboss_time.split(":")
            companyData.report_dailyboss_time = format(addHours(dateNow.setHours(DailyInsights[0], DailyInsights[1]),diffTimezone), 'h:mm A')
          }
  
          if(companyData.report_weeklyboss_time){
            const WeeklyInsights = companyData.report_weeklyboss_time.split(":")
            companyData.report_weeklyboss_time = format(addHours(dateNow.setHours(WeeklyInsights[0], WeeklyInsights[1]),diffTimezone), 'h:mm A')
          }
          if(companyData.report_monthlyboss_time){
            const monthlyInsights = companyData.report_monthlyboss_time.split(":")
            companyData.report_monthlyboss_time = format(addHours(dateNow.setHours(monthlyInsights[0], monthlyInsights[1]),diffTimezone), 'h:mm A')
          }
        }else{
          if(companyData.starttime){
            let DailyPulse;
            // if(companyData.starttime_show){
            //   DailyPulse = companyData.starttime_show.split(":")
            // }else{
              DailyPulse = companyData.starttime.split(":")
            // }
            companyData.starttime = format(dateNow.setHours(DailyPulse[0], DailyPulse[1]), 'h:mm A')
          }
  
          if(companyData.reminder_time){
            const DailyReminder = companyData.reminder_time.split(":")
            companyData.reminder_time = format(dateNow.setHours(DailyReminder[0], DailyReminder[1]), 'h:mm A')
          }
  
          if(companyData.report_dailyboss_time){
            const DailyInsights = companyData.report_dailyboss_time.split(":")
            companyData.report_dailyboss_time = format(dateNow.setHours(DailyInsights[0], DailyInsights[1]), 'h:mm A')
          }
  
          if(companyData.report_weeklyboss_time){
            const WeeklyInsights = companyData.report_weeklyboss_time.split(":")
            companyData.report_weeklyboss_time = format(dateNow.setHours(WeeklyInsights[0], WeeklyInsights[1]), 'h:mm A')
          }
          if(companyData.report_monthlyboss_time){
            const monthlyInsights = companyData.report_monthlyboss_time.split(":")
            companyData.report_monthlyboss_time = format(dateNow.setHours(monthlyInsights[0], monthlyInsights[1]), 'h:mm A')
          }
        }
        
        if(companyData.medal){
          if(companyData.medal.Creativity){
            companyData.Creativity = companyData.medal.Creativity
            companyData.CreativityTH =companyData.medals?companyData.medals.Creativity? companyData.medals.Creativity.th==companyData.medals.Creativity.en?"":companyData.medals.Creativity.th:"":""
          }

          if(companyData.medal.Initiative){
            companyData.Initiative = companyData.medal.Initiative
            companyData.InitiativeTH = companyData.medals?companyData.medals.Initiative? companyData.medals.Initiative.th==companyData.medals.Initiative.en?"":companyData.medals.Initiative.th:"":""
          }

          if(companyData.medal.Kindness){
            companyData.Kindness = companyData.medal.Kindness
            companyData.KindnessTH = companyData.medals?companyData.medals.Kindness? companyData.medals.Kindness.th==companyData.medals.Kindness.en?"":companyData.medals.Kindness.th:"":""
          }

          if(companyData.medal.Strength){
            companyData.Strength = companyData.medal.Strength
            companyData.StrengthTH = companyData.medals?companyData.medals.Strength? companyData.medals.Strength.th==companyData.medals.Strength.en?"":companyData.medals.Strength.th:"":""
          }

          if(companyData.medal.Charisma){
            companyData.Charisma = companyData.medal.Charisma
            companyData.CharismaTH =companyData.medals?companyData.medals.Charisma? companyData.medals.Charisma.th==companyData.medals.Charisma.en?"":companyData.medals.Charisma.th:"":""
          }

          if(companyData.medal.Intelligence){
            companyData.Intelligence = companyData.medal.Intelligence
            companyData.IntelligenceTH =companyData.medals?companyData.medals.Intelligence? companyData.medals.Intelligence.th==companyData.medals.Intelligence.en?"":companyData.medals.Intelligence.th:"":""
          }

        }else{
          companyData.Creativity = "Creativity"
          companyData.Initiative = "Initiative"
          companyData.Kindness = "Kindness"
          companyData.Strength = "Strength"
          companyData.Charisma = "Charisma"
          companyData.Intelligence = "Intelligence"
          
        }
        if(!companyData.medals){
          companyData.CreativityTH = ""
          companyData.InitiativeTH = ""
          companyData.KindnessTH = ""
          companyData.StrengthTH = ""
          companyData.CharismaTH = ""
          companyData.IntelligenceTH = ""

        }
        if(companyData['holiday_tag'] === undefined){
          companyData['holiday_tag'] = new Array()
        }
        if(companyData['holiday_val'] === undefined){
          companyData['holiday_val'] = new Array()
        }
        await firebase.firestore().collection('holliday').where("companyid", "==", user.company).where("date",">=",format(dateNow, 'YYYY-MM-DD')).orderBy('date').get()
        .then(function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
                const data = doc.data();
                let date_holiday = data['date'].split("-");

                companyData['holiday_tag'].push(format(data['date'], 'dddd, MMMM D, YYYY'))
                companyData['holiday_val'].push(new Date(`${date_holiday[0]}/${date_holiday[1]}/${date_holiday[2]}`))
            });
        });
        for(var value in companyData.hashtag){
         
          recognitionValue.push({
            ...companyData.hashtag[value],
            value: value,
            label:companyData.hashtag[value].name,
            labelTh:companyData.hashtag[value].name_th==companyData.hashtag[value].name?"#":companyData.hashtag[value].name_th,
          });
          oldRecognitionValue.push({
            ...companyData.hashtag[value],
            value: value,
            label:companyData.hashtag[value].name,
            labelTh:companyData.hashtag[value].name_th==companyData.hashtag[value].name?"#":companyData.hashtag[value].name_th,
          });
        }

          companyData.report_monthly_insights= companyData.report_monthlyboss?companyData.report_monthlyboss:"N"
          companyData.report_monthlyboss_time= companyData.report_monthlyboss_time
          companyData.happilyAssistAccess_checked= companyData.assist_access?companyData.assist_access:false
          companyData.medalsForLeaders_checked= companyData.leadership=="Y"?true:false
          companyData.recognitionValue_checked= companyData.hashtag_status? companyData.hashtag_status:false
          companyData.peerFeedbackInteractions_checked= companyData.peer_feedback=="Y"?true:false
          companyData.happilyVillageAccess_checked = companyData.house_village=="Y"?true:false
          companyData.create_topics= companyData.create_topics=="Y"?true:false
        
          applyCompanyData(companyData);
          companyData.townHallAgent_checked = Boolean(companyData.townhall_agent);
          companyData.townhall_themes = companyData.townhall_themes;
          companyData.emailNotifications = companyData.email_notifications;
          companyData.report_monthlyhr = companyData.report_monthlyhr == 'Y' ? true : false;
          companyData.report_activity_manager = companyData.report_activity_manager == 'Y' ? true : false;
          commit('setSettingOldDataMock',companyData) 
 
      },
      
      saveChanges({commit,rootState,dispatch,state}:any,value:any){
       
        firebase.database().ref(`excels_company/${rootState.authen.user.company}`).orderByChild('status').equalTo('Y').once('value', (snapshot) => {
          const excel: any = []
          const languageTemplate = buildLanguageTemplate(state.language)
          snapshot.forEach((childSnapshot) => {
            let data = childSnapshot.val()
            data.key = childSnapshot.key
            const diff = _.find(value.excels, {key:data.key})
            if(diff){
              data = diff
            }else{
              data.status = 'N'
            }
            excel.push(data)
          });

          for (const x in value.excels) {
            const diff = _.find(excel, {key:value.excels[x].key})
            if(diff === undefined) {
              excel.push(value.excels[x])
            }
          }
          const set: any = [];
          if(excel.length>0){
            for(const x in excel){
              const key = excel[x].key;
              excel[x].names = normalizeExcelNames(excel[x], languageTemplate)
              excel[x].name_th = excel[x].names.th ? excel[x].names.th : excel[x].name
              for(const lang in excel[x].names){
                if(lang !== 'th'&&lang !== 'en'){
                  if(excel[x].names[lang]==undefined){
                    delete excel[x].names[lang]
                  }
                }
              }
              set[excel[x].key] = excel[x];
  
            }
          }
          

          if (Object.entries(set).length >= 0) {
            //console.log("set",set)
            firebase.database().ref(`excels_company/${rootState.authen.user.company}`).set(set).then(() => {
              dispatch("getExcelsByCompany");
              // dispatch("getoldExcelsByCompany");
            });
          }
        });
        const company = value.company
        const form = value.form
        const dateNow = new Date()
        //console.log("form",form)
        const countMembers = value.countMembers.replace(/\(/g, "").replace(/\)/g, "")
        let convert_1 = new Convert(form.starttime);
        let starttimeShow = convert_1.convertTime();
        let starttimeSave = starttimeShow.split(":");
        let starttimeTimezone = starttimeShow.split(":");
        let calTime;
        // if(countMembers > 500){
        //   calTime = countMembers / 500;
        // }else{
          calTime = 0
        // }
        
        starttimeSave = format(addMinutes(new Date(0,0,0,starttimeSave[0],starttimeSave[1]),calTime * -1),'HH:mm')
        let report_dailyboss_time = '00:00';
        if(form.report_dailyboss_time&&form.report_dailyboss_time != "Invalid Date"){
          let convert_2 = new Convert(form.report_dailyboss_time);
          report_dailyboss_time = convert_2.convertTime();
        }
        let report_weeklyboss_time = '00:00';
        if(form.report_weeklyboss_time&&form.report_weeklyboss_time != "Invalid Date"){
          let convert_3 = new Convert(form.report_weeklyboss_time);
          report_weeklyboss_time = convert_3.convertTime();
        }
        let report_monthlyboss_time = '00:00';
        if(form.report_monthlyboss_time&&form.report_monthlyboss_time != "Invalid Date"){
          let convert_3 = new Convert(form.report_monthlyboss_time);
          report_monthlyboss_time = convert_3.convertTime();
        }
        let reminder_time = '00:00';
        if(form.reminder_time&&form.reminder_time != "Invalid Date"){
          let convert_4 = new Convert(form.reminder_time);
          reminder_time = convert_4.convertTime(); 
        }

        if(form.timezone){
          const dateNow = new Date()
          const setlengthTimezone = [];
          setlengthTimezone['7'] = [4, 4.5, 5, 5.5, 5.75, 6, 6.5, 7, 8, 9, 9.5, 10];
          setlengthTimezone['-7'] = [-4, -5, -6, -7, -8, -9, -10];
          setlengthTimezone['0'] = [-3.5, -3, -2, -1, 0, 1, 2, 3, 3.5];
          let globalTime = 0
          if (setlengthTimezone['7'].indexOf( parseFloat(form.timezone)) !== -1)
              globalTime = 7;
          if (setlengthTimezone['-7'].indexOf( parseFloat(form.timezone)) !== -1)
              globalTime = -7;
          if (setlengthTimezone['0'].indexOf( parseFloat(form.timezone)) !== -1)
              globalTime = 0;
              
          const diffTimezone = form.timezone - globalTime
          // const arr_starttimeShow:any = starttimeShow.split(":")
          // starttimeShow = format(subHours(dateNow.setHours(arr_starttimeShow[0], arr_starttimeShow[1]),diffTimezone), 'HH:mm')

          starttimeTimezone = format(dateNow.setHours(starttimeTimezone[0], starttimeTimezone[1]), 'HH:mm')

          const arr_starttimeSave:any = starttimeSave.split(":")
          starttimeSave = format(subHours(dateNow.setHours(arr_starttimeSave[0], arr_starttimeSave[1]),diffTimezone), 'HH:mm')

          const arr_report_dailyboss_time:any = report_dailyboss_time.split(":")
          report_dailyboss_time = format(subHours(dateNow.setHours(arr_report_dailyboss_time[0], arr_report_dailyboss_time[1]),diffTimezone), 'HH:mm')

          const arr_report_weeklyboss_time:any = report_weeklyboss_time.split(":")
          report_weeklyboss_time = format(subHours(dateNow.setHours(arr_report_weeklyboss_time[0], arr_report_weeklyboss_time[1]),diffTimezone), 'HH:mm')
          
          const arr_report_monthlyboss_time:any = report_monthlyboss_time.split(":")
          report_monthlyboss_time = format(subHours(dateNow.setHours(arr_report_monthlyboss_time[0], arr_report_monthlyboss_time[1]),diffTimezone), 'HH:mm')

          
          const arr_reminder_time:any = reminder_time.split(":")
          reminder_time = format(subHours(dateNow.setHours(arr_reminder_time[0], arr_reminder_time[1]),diffTimezone), 'HH:mm')
        }
        const performance_review=_.cloneDeep(form.performance_review)
        const reset_completed_monthly=form.performance_review&&form.performance_review.reset_completed_monthly?form.performance_review.reset_completed_monthly:false
        delete performance_review.reset_completed_monthly
        firebase.database().ref(`/company/${company}`).update({
          "medal":{
            Creativity: form.Creativity,
            Initiative: form.Initiative,
            Kindness: form.Kindness,
            Strength: form.Strength,
            Charisma: form.Charisma,
            Intelligence: form.Intelligence,
          },
          "medals":{
            Creativity:{en: form.Creativity,th: form.CreativityTH},
            Initiative:{en: form.Initiative,th: form.InitiativeTH}, 
            Kindness: {en: form.Kindness,th: form.KindnessTH}, 
            Strength:{en: form.Strength,th: form.StrengthTH}, 
            Charisma:{en: form.Charisma,th: form.CharismaTH}, 
            Intelligence: {en: form.Intelligence,th: form.IntelligenceTH},
          },
          house_village: form.happilyVillageAccess_checked?"Y":"N",
          assist_access:form.happilyAssistAccess_checked,
          leadership: form.medalsForLeaders_checked?"Y":"N",
          starttime: starttimeSave,
          starttime_timezone: starttimeTimezone,
          hashtag_status:form.recognitionValue_checked,
          peer_feedback:form.peerFeedbackInteractions_checked?"Y":"N",
          performance_review: performance_review || {enabled: true, overdue: 2, pending: 1, ai_review_feedback: true},
          limit: form.limit || {openend: 3},
          // starttime_show: starttimeShow,
          reminder_time: reminder_time,
          report_dailyboss_time: report_dailyboss_time,
          report_weeklyboss_time: report_weeklyboss_time,
          report_monthlyboss_time:report_monthlyboss_time,
          reset_completed_monthly:reset_completed_monthly,
          create_topics: form.create_topics==true?"Y":"N",

          // Town Hall Agent
          townhall_agent: form.townHallAgent_checked,
          townhall_themes: state.townHallThemes,

          // Email Notifications - BACKEND TODO: Implement email sending logic
          //
          // When these settings are saved, the backend should trigger email notifications based on these rules:
          //
          // 1. managerRewardRedemption: true
          //    - TRIGGER: When employee redeems a reward
          //    - RECIPIENT: Direct manager of the employee
          //    - EMAIL CONTENT: Employee name, reward details, redemption date
          //    - IMPLEMENTATION: Add notification logic to reward redemption handler
          //
          // 2. managerPeerFeedbackOutstanding: true
          //    - TRIGGER: When employee receives "Truly Outstanding" peer feedback rating
          //    - RECIPIENT: Direct manager of the employee
          //    - EMAIL CONTENT: Employee name, feedback details, rating info
          //    - IMPLEMENTATION: Add notification logic to peer feedback submission handler
          //
          // 3. managerActivityReport: true
          //    - TRIGGER: Scheduled (weekly/monthly - TBD)
          //    - RECIPIENT: All managers in company
          //    - EMAIL CONTENT: Manager's activity summary, team metrics, subordinate manager data if applicable
          //    - IMPLEMENTATION: Create scheduled job/cron that generates and sends reports
          //
          // 4. hrMonthlyReports: true
          //    - TRIGGER: Monthly schedule
          //    - RECIPIENT: All users with role "hr"
          //    - EMAIL CONTENT: Company-wide metrics, engagement data, insights
          //    - IMPLEMENTATION: Create monthly scheduled job for HR reporting
          //
          // HELPER FUNCTIONS NEEDED:
          // - getCompanyEmailSettings(companyId) - reads this data from Firebase
          // - getDirectManager(employeeId) - finds employee's manager
          // - getManagers(companyId) - gets all managers in company
          // - getHRUsers(companyId) - gets all HR users in company
          // - Email sending functions for each notification type
          //
          // FIREBASE PATH: /company/{companyId}/email_notifications
          // DATA STRUCTURE: { managerRewardRedemption: boolean, managerPeerFeedbackOutstanding: boolean, managerActivityReport: boolean, hrMonthlyReports: boolean }
          email_notifications: form.emailNotifications,
          activity_feed_use_nickname: form.activity_feed_use_nickname,
          report_monthlyhr: form.report_monthlyhr ? 'Y' : 'N',
          report_activity_manager: form.report_activity_manager ? 'Y' : 'N',
          updated:format(new Date(), 'YYYY-MM-DD HH:mm')
        })

        let data={}
       
        for(var i in value.recognitionValue){
          const recognitionNames = {
            ...(value.recognitionValue[i].names || {}),
            en: value.recognitionValue[i].label,
          }
          const rawThai = hasOwn(value.recognitionValue[i].names, 'th')
            ? value.recognitionValue[i].names.th
            : value.recognitionValue[i].name_th !== undefined
              ? value.recognitionValue[i].name_th
              : value.recognitionValue[i].labelTh
          recognitionNames.th = !rawThai || rawThai == "#" ? value.recognitionValue[i].label : rawThai

          data[value.recognitionValue[i].value]={
            name:value.recognitionValue[i].label,
            name_th:recognitionNames.th,
            order:parseInt(i)+1,
            names: recognitionNames,
          }
          for(var j in value.recognitionValue[i]){
            if(j!=='name'&&j!=='name_th'&&j!=='order'&&j!=='label'&&j!=='labelTh'&&j!=='value'){
              data[value.recognitionValue[i].value][j]=value.recognitionValue[i][j]
            }
          }
          data[value.recognitionValue[i].value].names = recognitionNames
         
        }
       
        firebase.database().ref(`/company/${rootState.authen.user.company}/hashtag`).set(data)
        let holliday_query = firebase.firestore().collection('holliday').where("companyid", "==", company).where("date",">=",format(dateNow, 'YYYY-MM-DD')).orderBy('date');
        holliday_query.get().then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            doc.ref.delete();
          });
            if(form.holiday_val && form.holiday_val.length > 0){
              _.forEach(form.holiday_val, (value, index) => {
                let dateHoliday = format(value, 'YYYY-MM-DD');
                let dateHoliday_split = dateHoliday.split("-");;
                firebase.firestore().collection("holliday").doc(company +'-'+ dateHoliday).set({
                  company:{
                    [company]: "Y",
                  },
                  companyid: company,
                  d: dateHoliday_split[2],
                  m: dateHoliday_split[1],
                  y: dateHoliday_split[0],
                  date: dateHoliday,
                  update: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                })
              });
            }
        });

        if (form.happilyVillageAccess_checked ) {
          var key: any = '';
          var xp_running = '';
          var distance_want = '';
          var xp_want = '';
          var newId = company;
          firebase.firestore().collection('houses').where('company','==', newId).get().then((querySnapshot)=> {
            firebase.database().ref('houses_range').orderByChild("min").equalTo(0).once('value', (snapshot) => {
                  snapshot.forEach((childSnapshot) => {
                      key = childSnapshot.key
                  });
                  firebase.database().ref('houses_achievement/'+key+'-mr').once('value', (snapshot) => {
                      var achievement = snapshot.val()
                      if(achievement != null){
                          xp_running = achievement.xp
                      }
                      let today = new Date();
                      let mm = today.getMonth() + 1;
                      firebase.database().ref('houses_monthlyrun/'+key+'-'+mm).once('value', (snapshot) => {
                          var monthlyrun = snapshot.val()
                          if(monthlyrun != null){
                              distance_want = monthlyrun.xp
                          }
                          firebase.database().ref('houses_xp/'+key+'-1').once('value', (snapshot) => {
                              var houses_xp = snapshot.val()
                              if(houses_xp != null){
                                  xp_want = houses_xp.xp
                              }
                              firebase.database().ref('houses').once('value', (snapshot) => {
                                  snapshot.forEach((childSnapshot) => {
                                      var _data = childSnapshot.val();
                                      _data.key = childSnapshot.key;
                                      var newrowid = newId+_data.key
                                      var house_data = {
                                          company : newId,
                                          house   : _data.key,
                                          house_name : _data.name,
                                          color : _data.color,
                                          level : 1,
                                          members : 0,
                                          xp : 0,
                                          // xp_running : xp_running,
                                          distance_want : distance_want,
                                          rang_id : key,
                                          xp_want : xp_want,
                                          xp_running_want : xp_running,


                                      }
                                      // New houses in Firestore , first open House Village
                                      // console.log(newrowid)
                                      // console.log(house_data)
                                      if(querySnapshot.empty){
                                          firebase.firestore().collection('houses').doc(newrowid).set(house_data).then(ref => {})
                                      }

                                      if(_data.image)
                                          _data.image = _data.image
                                      else
                                          _data.image = ''
                                      
                                      // New running_track_month_house in Firestore , first open House Village
                                      var running_track_month_house = {
                                          color : _data.color,
                                          company : newId,
                                          // date : moment.tz('Asia/Bangkok').format('YYYY-MM'),
                                          date : format(new Date(), 'YYYY-MM'),
                                          distance : 0,
                                          distance_want : distance_want,
                                          house   : _data.key,
                                          house_name : _data.name,
                                          xp_running_want : xp_running,
                                      }
                                      var id_running_track = newId+_data.key+'-'+format(new Date(), 'YYYY-MM')
                                      // var deleteDoc =firestore.collection('running_track_month_house/').doc(id_running_track).delete();
                                      // console.log(id_running_track)
                                      // console.log(running_track_month_house)
                                      firebase.firestore().collection('running_track_month_house/').doc(id_running_track).get().then((doc)=> {
                                          if (!doc.exists) {
                                            firebase.firestore().collection('running_track_month_house').doc(id_running_track).set(running_track_month_house).then(ref => {})
                                          }else{
                                           
                                          }
                                      })
                                    });
                                    value.messageLoading.close();
                                    value.thisvue.$message({
                                      type: 'success',
                                      message: 'Your settings have been updated',
                                    });
                              });
                          });
                      });
                  });
              });
          });
        }else{
          value.messageLoading.close();
          value.thisvue.$message({
            type: 'success',
            message: 'Your settings have been updated',
          });
        }
        
      },
      async getExcelsByCompany({commit,rootState,state}:any){
        const excels_master = (await firebase.database().ref(`excels`).once('value')).val()
       
        //console.log('excels_master',excels_master)
        const excels_detail = await getExcelsDetail()
       // console.log('excels_detail',excels_detail)

        //const excels_detail = (await firebase.database().ref(`excels_detail/`).once('value')).val()
       
        commit('setExcelsDetail',excels_detail)
       
        //console.log('excels_detail',excels_detail)
        const language = buildLanguageTemplate(state.language)
  
        firebase.database().ref(`excels_company/${rootState.authen.user.company}`).orderByChild('status').equalTo('Y').once('value', (snapshot) => {
          const excel: string[] = []
          snapshot.forEach((childSnapshot) => {
            const data = childSnapshot.val()
            data.key = childSnapshot.key
            const _data=_.clone(data);
            _data.names = normalizeExcelNames(_data, language)
            _data.name_th=data.name_th==data.name?"":data.name_th
            if(excels_master[data.key]){
              _data.status_master=true
            }else{
              _data.status_master=false
            }
            excel.push(_data)
          });
          
          const _excel=_.cloneDeep(excel)
          commit('setExcels',excel)
          commit('setOldExcels',_excel)
        });
      },
      getoldExcelsByCompany({commit,rootState}:any){
        firebase.database().ref(`excels_company/${rootState.authen.user.company}`).orderByChild('status').equalTo('Y').once('value', (snapshot) => {
          const excel: string[] = []
          snapshot.forEach((childSnapshot) => {
            const data = childSnapshot.val()
            data.key = childSnapshot.key
            data.name_th=data.name_th==data.name?"":data.name_th
            excel.push(data)
          });
          commit('setOldExcels', excel)
        });
      },
      removeExcels({commit,rootState,state,dispatch}:any,item){
        if(item.key){
          /*firebase.database().ref(`excels_company/${rootState.authen.user.company}/${item.key}`).update({
            status:'N'
          });*/
          const data = _.clone(state.excels)
          _.remove(data, (e:any) => {
            return e.key == item.key;
          });
          commit('setExcels',data)
          
        }
      },
      createExcels({commit,rootState,state,dispatch}:any,item){
        if(item){
          /*firebase.database().ref(`excels_company/${rootState.authen.user.company}`).push({
            name:item,
            name_th:item,
            status:'Y',
            updated: format(new Date(), 'YYYY-MM-DD HH:mm')
          }).then((snap)=>{
            
          });*/
          const data = _.clone(state.excels)
          data.push({
            name:item,
            name_th:item,
            status:'Y',
            updated: format(new Date(), 'YYYY-MM-DD HH:mm'),
            createdate: format(new Date(), 'YYYY-MM-DD HH:mm'),
            key:`rand-${Math.floor(Math.random() * 999999)}`,
          })
          commit('setExcels',data)
         
          
        }
      },
      // saveRecognition({commit,rootState,dispatch,state}:any,value:any){
      //   let data={}
      //   for(var i in value.recognitionValue){
      //     data[value.recognitionValue[i].value]={
      //       name:value.recognitionValue[i].label,
      //       name_th:value.recognitionValue[i].label
      //     }
      //   }
      //   let status={
      //     hashtag_status:value.settingDataMock.recognitionValue_checked
      //   }

      // //  firebase.database().ref(`/company/${rootState.authen.user.company}`).update(status)
      //  firebase.database().ref(`/company/${rootState.authen.user.company}/hashtag`).set(data)
      // //  commit("setSettingOldDataMock",value.settingDataMock)
      // //  commit("setSettingOldDataMock",value.recognitionValue)
       
      // },
      newIdhashtag({commit,rootState,dispatch,state}:any,value:any){
        let newid=firebase.database().ref(`/company/${rootState.authen.user.company}/hashtag`).push().key;
        commit("sethashTagId",newid)
      },
      async getmemberInteam({commit,state,dispatch,rootState}:any, value:any){
        //console.log('getmemberInteam',value)
        commit('setMultipleState',{loading_preset:true})
        //commit('setloading_preset',true)
        const organization1level:any={}
        let user_all=await getUserAll(rootState.authen.user.company)//(await firebase.database().ref('users').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
        const group_memberinteam:any=_.groupBy(user_all, function (b) {
          return b.team;
        });
        
        const team_all=await getTeamByCompany(rootState.authen.user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
        const memberinteam_all:any={}
        let memberinteam:any={}
        await firebase.firestore().collection('organization1level').where("company", "==", rootState.authen.user.company).get()
            .then((querySnapshot)=> {
                    querySnapshot.forEach((doc)=> {
                        const data=doc.data()
                        if(!organization1level[data.team_id]){
                          organization1level[data.team_id]=data.parent
                        }
                        if(!memberinteam_all[data.team_id]){
                          memberinteam_all[data.team_id]={users:[],name:team_all[data.team_id]?team_all[data.team_id].name:'',id:data.team_id}
                        }
                        if(!memberinteam[data.team_id]){
                          memberinteam[data.team_id]={users:[],name:team_all[data.team_id]?team_all[data.team_id].name:'',id:data.team_id}
                        }
                        if(data.parent){
                          for(const key  in data.parent){
                           
                       
                            if(group_memberinteam[key]){
                              memberinteam_all[data.team_id].users.push(...group_memberinteam[key])
                              memberinteam[data.team_id].users.push(...group_memberinteam[key])
                            }
                          }
                          
                        }   
                                      
                    });
                    for(const key in team_all){
                      if(!memberinteam_all[key]){
                        if(group_memberinteam[key]){
                          memberinteam_all[key]={users:group_memberinteam[key],name:team_all[key].name,id:key}
                        }
                      }
                      if(!memberinteam[key]){
                        if(group_memberinteam[key]){  
                          memberinteam[key]={users:group_memberinteam[key],name:team_all[key].name,id:key}
                        }
                      }
                    }
                    //console.log("memberinteam",memberinteam)
                    memberinteam=_.orderBy(memberinteam, 'name', 'asc')
                    for(const key in user_all){
                      user_all[key].team_name=team_all[user_all[key].team].name
                    }
                    user_all=_.orderBy(user_all, 'firstname', 'asc')
                  
                    const payload={
                      organization1level: organization1level,
                      memberinteam: memberinteam,
                      memberInteamAll_master: memberinteam_all,
                      memberInteamAll: memberinteam_all,
                      allUser: user_all,
                      member: user_all
                    }
                    commit('setMultipleState', payload)
                    dispatch('getPresets',value)
                   
                    
                    
             });
        
      },
      async searchmemberandteamandMember({commit,state,dispatch,rootState}:any, value:any){
        //console.log('searchmemberandteam',value)
        const type=value.type
        let memberinteam:any={}
        var re = new RegExp(value.value, 'gi')
        if(type=='team'){
          
          const _memberinteam:any=_.cloneDeep(state.memberInteamAll)
          if (value.value) {
            for(const key in _memberinteam){
              if(_memberinteam[key].name.match(re)){
                memberinteam[key]=_memberinteam[key]
              }
            }
            //console.log("memberinteam",memberinteam)
           
            memberinteam=_.orderBy(memberinteam, 'name', 'asc')
            commit('setMultipleState', {memberinteam: memberinteam})
          }else{
            commit('setMultipleState', {memberinteam:state.memberInteamAll})
          }
        }
        else{
          const _memberinteam:any=_.cloneDeep(state.allUser)
          if (value.value) {
            for(const key in _memberinteam){
              //console.log("key",_memberinteam[key].firstname)
              if(_memberinteam[key].firstname.match(re)){
                memberinteam[key]=_memberinteam[key]
              }else if(_memberinteam[key].lastname.match(re)){
                memberinteam[key]=_memberinteam[key]
              }else if(_memberinteam[key].email.match(re)){
                memberinteam[key]=_memberinteam[key]
              }else if(_memberinteam[key].team_name.match(re)){
                memberinteam[key]=_memberinteam[key]
              }
            }
            //console.log("memberinteam",memberinteam)
            memberinteam=_.orderBy(memberinteam, 'firstname', 'asc')
            commit('setMultipleState', {member:memberinteam})
           
          }else{
            commit('setMultipleState', {member:state.allUser})
          }
        }
      },
      async getPresets({commit,state,dispatch,rootState}:any){
        //console.log("getPresets")
        commit('setMultipleState',{loading_preset:true})
        // commit('setloading_preset',true)
        let memberInteamAll=_.cloneDeep(state.memberInteamAll_master)
        //console.log("memberInteamAll",memberInteamAll)
        const preset_list:Array<any>=[]
        const team_all=await getTeamByCompany(rootState.authen.user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
        const user_all=await getUserAll(rootState.authen.user.company)//(await firebase.database().ref('users').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
        const boss_all=(await firebase.database().ref(`boss/${rootState.authen.user.company}`).once('value')).val()
        const team_used_preset:Array<any>=[]
        const user_used_preset:Array<any>=[]
        firebase.firestore().collection('holiday_template').where("company", "==", rootState.authen.user.company).get()
        .then(async function (querySnapshot) {
          querySnapshot.forEach((doc) => {
            const data = doc.data()
            data.id=doc.id
            data.focus_preset=false
            //console.log("data",data.teams)
            if(data.teams){
              if(!team_used_preset[data.id]){
                team_used_preset[data.id]=[]
              }
              team_used_preset[data.id].push(...data.teams)
            }
            if(data.users){
              if(!user_used_preset[data.id]){
                user_used_preset[data.id]=[]
              }
              user_used_preset[data.id].push(...data.users)
            }
            
            preset_list.push(data)
          })
          const member_groupbyteam:any=_.groupBy(user_all, function (b) {
            return b.team;
          });
          
          
          for(const item of preset_list){
            
            item.total_assignments=0
            item.data_users=[]
            item.data_team=[]
            if(item.users){
              for(const x of item.users){
                const emailKey=x.replace(/\./g, "||")
                const user:any={}
                if(user_all[emailKey]){
                  user.email=user_all[emailKey].email
                  user.firstname=user_all[emailKey].firstname
                  user.lastname=user_all[emailKey].lastname
                  user.boss=user_all[emailKey].boss
                  user.team=user_all[emailKey].team
                  user.team_name=team_all[user_all[emailKey].team]?team_all[user_all[emailKey].team].name:''
                  user.profilepic_crop=user_all[emailKey].profilepic_crop
                  item.data_users.push(user)
                }
                item.total_assignments+=1
                for(const key in memberInteamAll){
                  const _user=_.filter(memberInteamAll[key].users, function(o) { return o.email!==user.email });
                  if(_user&&_user.length>0){
                    //console.log("memberInteamAll",_user)
                    // const _member=_.find(memberInteamAll[key].users, function(o) { return o.email==user.email });
                    _user.preset_name=item.name
                    memberInteamAll[key].users=_user
                  }
                }


              }

            }
            
            if(item.teams){
              for(const team of item.teams){
                
                const organization1level=state.organization1level[team]
                const team_data=team_all[team]
                let memberbyteem=0
                if(organization1level){
                  for(const team_id in organization1level){

                    if(member_groupbyteam[team_id]){
                      for(const user of member_groupbyteam[team_id]){
                        
                        //check user used preset
                        for(const id_preset in user_used_preset){
                          const _finduser=_.find(user_used_preset[id_preset], function(o) { return o==user.email });
                          if(_finduser){
                              user.user_preset_id=id_preset
                              
                          }
                        }
                        for(const id_preset in team_used_preset){
                          const _findteam=_.find(team_used_preset[id_preset], function(o) { return o==user.team });
                            if(_findteam){
                              if(!user.user_preset_id){
                                user.team_preset_id=id_preset
                              }
                              // user team
                              for(const key in memberInteamAll){
                                const _user=_.filter(memberInteamAll[key].users, function(o) { return o.email==user.email });
                                if(_user&&_user.length>0&&key!==user.team){
                                  const _user_team=_.filter(memberInteamAll[key].users, function(o) { return o.email!==user.email });
                                  memberInteamAll[key].users=_user_team
                                  
                             
                                }
                              }

                            }



                          }
                              if(!user.team_preset_id&&!user.user_preset_id){
                             
                                //console.log("id_prese!!!!!!!!!",id_preset)
                                const emailkey_boss=user.boss.replace(/\./g, "||")
                                  
                                const temp_team=boss_all[emailkey_boss].team

                                
                                
                              
                                const checkteam_preset=await dispatch('checkTeamUsed',{user_email:user.email,boss_email:user.boss,team:temp_team,alluser:user_all,boss_all:boss_all,team_used_preset:team_used_preset})
                             

                                
                                  const _user=_.filter(memberInteamAll[team].users, function(o) { return o.email==user.email });
                                  if(_user&&_user.length>0&&team!==(checkteam_preset&&checkteam_preset.team_id)){
                                    const _user_team=_.filter(memberInteamAll[team].users, function(o) { return o.email!==user.email });
                                    memberInteamAll[team].users=_user_team                              
                                  }

                                
                                

                                


                                if(checkteam_preset&&checkteam_preset.id_preset==item.id){
                                  
                                  
                                  memberbyteem+=1
                                  item.total_assignments+=1
                                }
                              }else if(user.team_preset_id==item.id){
                                memberbyteem+=1
                                item.total_assignments+=1

                              }
                          //}

                        }
                    }




                    // }
                  }
                  if(team_data){
                    team_data.membersteams=memberbyteem
                    team_data.id=team
                    item.data_team.push(team_data)
                  }
                }else{
                  const team_data=team_all[team]
                  if(member_groupbyteam[team]){
                    if(team_data){
                      team_data.membersteams=member_groupbyteam[team].length
                      item.total_assignments+=member_groupbyteam[team].length
                      team_data.id=team
                      item.data_team.push(team_data)
                    }
                    
                  }
                  
                }
              }
            }

            
          }
         
          memberInteamAll=_.orderBy(memberInteamAll, 'name', 'asc')
          const payload={
            memberinteam: memberInteamAll,
            memberInteamAll: memberInteamAll,
            presetlist:preset_list,
            presetlistAll:preset_list,
          }
          commit('setMultipleState', payload)
          commit('setMultipleState',{loading_preset:false})
      
        })
        
      },
      async checkTeamUsed({state,rootState,dispatch}:any, value:any){
        
        const user_all=value.alluser
        const boss_all=value.boss_all
        const user_email=value.user_email
        const boss_email=value.boss_email
        const team_id=value.team
        const team_used_preset=value.team_used_preset
        for(const id_preset in team_used_preset){
          
          if(team_id!=''){
          const _findteam=_.find(team_used_preset[id_preset], function(o) { return o==team_id });
            if(_findteam){
    
              return {id_preset:id_preset,team_id:team_id}
            }
          }
        }
        const emailkey = boss_email.replace(/\./g, "||")
        if (user_all[emailkey] && user_all[emailkey].boss) {
        const emailkey=boss_email.replace(/\./g, "||")
        const temp_boss=user_all[emailkey].boss
        const emailkey_boss=user_all[emailkey].boss.replace(/\./g, "||")
        const temp_team=user_all[emailkey_boss].team
        if (temp_team) {
          return await dispatch('checkTeamUsed',{user_email:user_email,boss_email:temp_boss,team:temp_team,alluser:user_all,boss_all:boss_all,team_used_preset:team_used_preset})
        }
        }
      },
      async deletePreset({commit,state,dispatch,rootState}:any, value:any){
        //console.log('deletePreset',value)
        await firebase.firestore().collection('holiday_template').doc(value.preset_id).delete()
        dispatch('getPresets')
      },
      async updateAndCreatePreset({commit,state,dispatch,rootState}:any, value:any){
       // console.log('updateAndCreatePreset',value)
        commit('setMultipleState',{loading_preset:true})
        //commit('setloading_preset',true)
        const preset_form=_.cloneDeep(value.preset)
        const duplicate=_.cloneDeep(value.duplicate)
        if(duplicate){
          for(const key in duplicate){
            if(duplicate[key].status_duplicate_team==true&&duplicate[key].status_duplicate_user==true){
              const team:any=[]
              const user:any=[]
              const newId=duplicate[key].id
              if(duplicate[key].team){
                for(const i in duplicate[key].team){
                  team.push(duplicate[key].team[i])
                }
              }
              if(duplicate[key].users){
                for(const i in duplicate[key].users){
                  user.push(duplicate[key].users[i])
                }
              } 
              const data:any={
                users:user,
                teams:team,
                modified_at:format(new Date(),'YYYY-MM-DD HH:mm:ss')
              }
              await firebase.firestore().collection('holiday_template').doc(newId).update(data)

            }
            else if(duplicate[key].status_duplicate_team==true){
              const team:any=[]
              const newId=duplicate[key].id
              if(duplicate[key].team){
                for(const i in duplicate[key].team){
            
                  team.push(duplicate[key].team[i])
                }
              }

              const data:any={
                teams:team,
                modified_at:format(new Date(),'YYYY-MM-DD HH:mm:ss')
              }
              await firebase.firestore().collection('holiday_template').doc(newId).update(data)
            }else if(duplicate[key].status_duplicate_user==true){
              const user:any=[]
              const newId=duplicate[key].id
              if(duplicate[key].users){
                for(const i in duplicate[key].users){
                  user.push(duplicate[key].users[i])
                }
              } 
              const data:any={
                users:user,
                modified_at:format(new Date(),'YYYY-MM-DD HH:mm:ss')
              }
              await firebase.firestore().collection('holiday_template').doc(newId).update(data)
            }
          }
        }
        let user:any=[]
        let team:any=[]
        if(preset_form.users){
          for(const i in preset_form.users){
            //console.log("i",i)
            user.push(preset_form.users[i].email)
          }
        }
        if(preset_form.team){
          for(const i in preset_form.team){

            team.push(preset_form.team[i].id)
          }
        }
        let holiday_day={'Monday':false,'Tuesday':false,'Wednesday':false,'Thursday':false,'Friday':false,'Saturday':false,'Sunday':false}
        if(preset_form.dayoff){
          for(const i in preset_form.dayoff){
           
            holiday_day[preset_form.dayoff[i]]=true
            
            //console.log("i",holiday_day[preset_form.dayoff[i]])
            
            
          }
        }

       // console.log("user",user)
        // Process holiday_dates - convert Date objects to YYYY-MM-DD strings
        let holiday_dates: string[] = []
        if (preset_form.holiday_dates_val && preset_form.holiday_dates_val.length > 0) {
          for (const dateVal of preset_form.holiday_dates_val) {
            if (dateVal instanceof Date) {
              holiday_dates.push(format(dateVal, 'YYYY-MM-DD'))
            } else if (typeof dateVal === 'string') {
              holiday_dates.push(dateVal)
            }
          }
        }
        
        let newId=''
        const data:any={
          name:preset_form.name,
          users:user,
          company:rootState.authen.user.company,
          holiday_day:holiday_day,
          holiday_dates:holiday_dates,  // NEW: specific dates
          company_holiday:preset_form.company_holiday,
          teams:team,
          modified_by:rootState.authen.user.email,
          status:true,
        }
        if(!preset_form.team){
          delete data.teams
        }
        if(!preset_form.users){
          //console.log("preset_form.users",preset_form.users)
          delete data.users
        }
       // console.log("data",data)
        try {
        if(preset_form.preset_id){

          newId=preset_form.preset_id
          data.modified_at=format(new Date(),'YYYY-MM-DD HH:mm:ss')
          await firebase.firestore().collection('holiday_template').doc(newId).update(data)
          //.log('update preset success')
        }else{

          //console.log('create preset')
          data.created_at=format(new Date(),'YYYY-MM-DD HH:mm:ss')
          await firebase.firestore().collection('holiday_template').doc().set(data) 
      
          //console.log('create preset success')
        }
        dispatch('getPresets')
        } catch (error) {
          //console.error('Error updating or creating preset:', error)
        }
       
        

      },
      async searchData_preset({commit,state,dispatch,rootState}:any, value:any){
        //.log('searchData_preset',value)
        var re = new RegExp(value, 'gi') 
        const presetlistAll:any=_.cloneDeep(state.presetlistAll)
        //console.log("presetlistAll",presetlistAll)
        const presetlist:any=[]
        if (value) {
          for(const key in presetlistAll){
            //console.log("presetlistAll[key].name",presetlistAll[key].name)
            if(presetlistAll[key].name.match(re)){
              presetlist.push(presetlistAll[key])
            }
          }
          //console.log("presetlist",presetlist)
          commit('setMultipleState',{presetlist:presetlist})
        
        }else {
          commit('setMultipleState',{presetlist:presetlistAll})
        }
       
      },
      async savePeerFeedbackTagChanges({commit,state,dispatch,rootState}:any, value:any){
        const data=_.cloneDeep(value)
         
        const excels_detail=data.attributes
        const master_excels_detail=_.cloneDeep(state.excels_detail)
        master_excels_detail[data.key]=excels_detail
        commit('setExcelsDetail',master_excels_detail)
        //console.log('master_excels_detail',master_excels_detail)
        if(data.new_excel){
          await firebase.database().ref(`excels_company/${rootState.authen.user.company}/${data.key}`).set({
            name:data.name,
            key:data.key,
            name_th:data.name_th?data.name_th:data.name,
            names:{
              en:data.name,
              th:data.name_th?data.name_th:data.name,
            },
            status:"Y",
            type:"value_based",
            updateStatus:format(new Date(),'YYYY-MM-DD HH:mm:ss'),
            updateBy:rootState.authen.user.email,
            createdate:format(new Date(),'YYYY-MM-DD HH:mm:ss'),
          }).then(()=>{
            dispatch('getExcelsByCompany')
            dispatch('authen/addLogs',{
              company:rootState.authen.user.company,
              createdate:format(new Date(),'YYYY-MM-DD HH:mm:ss'),
              table:'excels_company',
              status:'create',
              id:data.key,
              user:rootState.authen.user.email
            },{root:true})
          })
        }
        if(excels_detail){
          await firebase.database().ref(`excels_detail/${data.key}`).set(excels_detail).then(()=>{
            /*save logs*/
          dispatch(
            "authen/addLogs",
            {
              company: rootState.authen.user.company,
              createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
              table: "excels_detail",
              status: "updated",
              user: rootState.authen.user.email,
            },
            { root: true }
            );
          })
        }
      },
      async callAIAttributeGeneration({commit,state,dispatch,rootState}:any, value:any){
        //console.log('callAIAttributeGeneration====',value)
        

        //const url=`http://localhost:80/openai/get_attribute?skill=${value.skill}&lang=${value.languages}`
        const url=`https://api-node.happily.ai/openai/get_attribute?skill=${value.skill}&lang=${value.languages}`
        console.log('url',url)
        const response = await axios.post(url)
        return response.data

      }
      
    },
    getters: {
      setting : (state:any) => {
        return state.settingData
      },
      excels : (state:any) => {
        return state.excels
      },
      recognitionValue: (state:any) => {
        return state.recognitionValue
      },
      hashTagId: (state:any) => {
        return state.hashTagId
      },
      oldRecognitionValue: (state:any) => {
        return state.oldRecognitionValue
      },

      settingOldDataMock: (state:any) => {
        return state.settingOldDataMock
      },
      multiLang: (state:any) => {
        return state.multiLang
      },
      oldExcels: (state:any) => {
        return state.oldExcels
      },
      language: (state:any) => {
        return state.language
      },
      memberinteam: (state:any) => {
       
        return state.memberinteam
      },
      member: (state:any) => {
        
        return state.member
      },
      presetlist: (state:any) => {
        //console.log("state.presetlist",state.presetlist)
        return state.presetlist
      },
      presetlistAll: (state:any) => {
        return state.presetlistAll
      },
      loading_preset: (state:any) => {
        return state.loading_preset
      },
      townHallThemes: (state:any) => {
        return state.townHallThemes
      },
      excels_detail: (state:any) => {
        return state.excels_detail
      }
    }
  }
